import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
} from 'recompose';
import {
  get,
  noop,
  orderBy,
  groupBy
} from 'lodash';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import CaretDown from '@material-ui/icons/KeyboardArrowDown';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import {
  Avatar,
  injectIntl,
} from 'components';
import { getFullNameOrEmail } from 'helpers/utils';
import { loginOrganization } from 'redux/auth/actions';
import { getRequestingSelector } from 'redux/selectors';

const styles = () => ({
  avatarActive: {
    border: '2px solid #45A7FF',
    pointerEvents: 'none',
    width: 50,
    height: 50,
  },
  avatarInActive: {
    border: '2px solid #45A7FF',
    cursor: 'pointer',
    width: 50,
    height: 50,
  },
  item: {
    marginTop: 5,
    padding: '10px 5px 5px 0px',
  },
  itemText: { paddingRight: 0 },
});

class SidebarTopItem extends Component {
  static contextTypes = {
    brands: PropTypes.shape({}),
    currentMember: PropTypes.shape({}),
    currentUser: PropTypes.shape({}),
  };

  static propTypes = {
    account: PropTypes.shape({}),
    classes: PropTypes.shape({}).isRequired,
    loginOrganization: PropTypes.func.isRequired,
    member: PropTypes.shape({}),
    organizations: PropTypes.arrayOf(PropTypes.shape({})),
    tokenInfoRequesting: PropTypes.bool,
    formatMessage: PropTypes.func.isRequired,
    history: PropTypes.shape({}).isRequired,
    buyers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
    sellers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
  };

  static defaultProps = {
    account: {},
    member: null,
    organizations: [],
    tokenInfoRequesting: false,
  };

  state = {
    anchorEl: null,
    loggingIn: false,
    fillOutDialogOpen: false
  };

  handleFillOutDialogClose = () => {
    this.setState({ fillOutDialogOpen: false });
  }

  handleClick = (event) => {
    if (this.isDeactivated()) {
      this.setState({ fillOutDialogOpen: true });
      return;
    }

    const { organizations } = this.props;
    if (organizations && organizations.length > 1) {
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  handleSelect = (memberId) => {
    const {
      history,
    } = this.props;
    this.setState({ loggingIn: true });
    this.props.loginOrganization({
      memberId,
      onSuccess: (data) => {
        this.setState({ anchorEl: null, loggingIn: false });
        if (data) {
          const role = {
            2: 'Buyer',
            3: 'Distributor',
            4: 'Seller',
            5: 'Consumer',
          }[data.user.account.currentRoleId] || 'Personal';
          if (role === 'Personal') {
            history.push('/settings');
            window.location.reload();
          } else {
            history.push('/track-orders');
            window.location.reload();
          }
        }
      },
    });
  };

  handleAvatarClick = (memberId) => {
    const {
      account,
      organizations,
      history,
    } = this.props;
    const currentRoleId = get(organizations[0], 'account.currentRoleId');
    const role = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[currentRoleId] || 'Personal';
    const { account: { email } } = organizations[0];
    if (email !== account.email) {
      this.setState({ loggingIn: true });
      this.props.loginOrganization({
        memberId,
        onSuccess: () => {
          this.setState({ anchorEl: null, loggingIn: false });
          if (role !== 'Personal') {
            history.push('/track-orders');
          } else {
            history.push('/settings');
          }
          window.location.reload();
        },
      });
    } else if (email === account.email && role !== 'Personal') {
      history.push('/track-orders');
    } else if (email === account.email && role === 'Personal') {
      history.push('/settings');
    }
  };

  isDeactivated = () => {

    const { currentMember, currentUser } = this.context;

    let deactivated = false;
    if (!currentMember && currentUser) {
      const {
        account: {
          profile: {
            firstName,
            lastName,
            mobile,
            companyName,
            addresses,
          },
        },
        roleId,
      } = currentUser || { account: { profile: { addresses: [{}] } } };

      const { address, city, state, zipcode } = addresses && addresses.length ? addresses[0] : {};

      if (roleId && (!firstName || !lastName || !mobile || !companyName
        || !address || !city || !state || !zipcode)) {
        deactivated = true;
      }
      if (!roleId && (!firstName || !lastName || !mobile)) {
        deactivated = true;
      }
    }
    return deactivated;
  }

  render() {
    const { brands, currentUser } = this.context;
    const {
      account,
      classes,
      member,
      organizations,
      formatMessage,
      tokenInfoRequesting,
      buyers,
      sellers,
    } = this.props;
    const { anchorEl, loggingIn, fillOutDialogOpen } = this.state;
    const currentRoleId = get(organizations[0], 'account.currentRoleId');
    const role = {
      2: 'Buyer',
      3: 'Distributor',
      4: 'Seller',
      5: 'Consumer',
    }[currentRoleId] || 'Personal';
    const fullNameOrEmail = getFullNameOrEmail(organizations[0].account);

    const buyerBlockedContacts = buyers.filter(x =>
      x.sellerProfile.email === currentUser.organizations[0].account.email && x.isDeleted === true);
    const buyerBlockedEmails = [];
    buyerBlockedContacts.forEach((buyer) => {
      buyerBlockedEmails.push(buyer.buyerProfile.email);
    });

    const sellerBlockedContacts = sellers.filter(x =>
      x.buyerProfile.email === currentUser.organizations[0].account.email && x.isDeleted === true);
    const sellerBlockedEmails = [];
    sellerBlockedContacts.forEach((seller) => {
      sellerBlockedEmails.push(seller.sellerProfile.email);
    });

    const shiftedOrganizations = orderBy(organizations.slice(1).filter(item =>
      !item.accessRequest && !item.pending &&
      buyerBlockedEmails.indexOf(item.organizationEmail) === -1 &&
      sellerBlockedEmails.indexOf(item.organizationEmail) === -1), [o => get(o, 'account.profile.companyName')]);

    // sort organizations by role, first sellers and then customers
    const groupOrganizationsByRole = groupBy(shiftedOrganizations, org => org.account.currentRoleId);
    const orderedOrganizations = groupOrganizationsByRole[4] ? (groupOrganizationsByRole[2] ? groupOrganizationsByRole[4].concat(groupOrganizationsByRole[2]) : groupOrganizationsByRole[4] ): shiftedOrganizations;

    const { id, account: { email, profile: { companyName, logoUrl } } } = organizations[0];
    const organizationCount = shiftedOrganizations && shiftedOrganizations.length;
    const clickable = true;

    const titleStr = (
      <div className="top-info">
        <div className="logo-and-avatar">
          <img
            alt="sun"
            className="beta-logo"
            src={brands.logoUrl}
          />
          {organizations[0] && (
            <Avatar
              highlighted
              clickable={clickable}
              src={logoUrl}
              key={email}
              fullName={companyName || email}
              onClick={() => this.handleAvatarClick(id)}
            />
          )}
        </div>
        {organizations[0] && (
          <div className="company-title">
            <span className="field-description uppercase">{formatMessage(role)}: </span>
            <span style={{ color: '#45A7FF' }}>{fullNameOrEmail}</span>
          </div>
        )}
      </div>
    );
    const organizationsMenu = (
      <div className={`loading-enabled ${tokenInfoRequesting && 'loading'}`}>
        {
          Boolean(organizationCount) && (
          <div className="team-button">
            <Button
              aria-owns={anchorEl ? 'simple-menu' : null}
              aria-haspopup="true"
              onClick={this.handleClick}
              style={{
                background: '#4695EC',
                color: 'white',
                fontSize: 11,
                fontWeight: 'bold',
                display: 'block',
                padding: 5,
                paddingLeft: 10,
                textAlign: 'center',
                textTransform: 'none',
                width: '100%',
              }}
              variant="contained"
            >
              <div style={{
                fontSize: 10,
                fontWeight: 'normal',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'space-between',
              }}>
                {member ? (account.profile.companyName || account.email) : 'Vendor & Customer Log-Ins '}
                {Boolean(organizationCount) && (
                  organizationCount
                )}
                <CaretDown />
              </div>
            </Button>
          </div>
          )
        }
        <Menu
          anchorEl={anchorEl}
          id="simple-menu"
          onClose={loggingIn ? noop : this.handleClose}
          open={Boolean(anchorEl)}
        >
          {orderedOrganizations.map((organization, index) => (
            <MenuItem
              disabled={loggingIn || (!member && !organization.id)
                || (member && parseInt(member.id, 10) === parseInt(organization.id, 10))}
              key={index}
              onClick={() => this.handleSelect(organization.id)}
              style={{height: 8}}
            >
              {organization.account.profile.companyName}
            </MenuItem>
          ))}
        </Menu>
      </div>
    );
    return (
      <div className="sidebar-header" style={{ color: brands.navTextColor || 'white' }}>
        <ListItem className={classes.item}>
          <ListItemText
            classes={{ root: classes.itemText }}
            disableTypography
            primary={titleStr}
            secondary={organizationsMenu}
          />
        </ListItem>
        <Dialog
        open={fillOutDialogOpen}
        onClose={this.handleFillOutDialogClose}
        >
        <DialogTitle>
          
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
          Complete Required Fields To Use FRESHr.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleFillOutDialogClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  tokenInfoRequesting: getRequestingSelector('auth', 'tokenInfo')(state),
});

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  loginOrganization: payload => dispatch(loginOrganization(payload)),
});

export default compose(
  setDisplayName('SidebarTopItem'),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  injectIntl,
  withStyles(styles),
)(SidebarTopItem);
